import { render, staticRenderFns } from "./CandidateSignUp.vue?vue&type=template&id=a5f7b8b2&"
import script from "./CandidateSignUp.vue?vue&type=script&lang=js&"
export * from "./CandidateSignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports